import { useRef, forwardRef } from "react";
import { Form } from "react-bootstrap";
import { reducerActions } from "../../../Reducers/FormReducer";

const CheckBoxBase = forwardRef((props, ref) => {

  const checkboxRef = useRef(null);

  const {
    field,
    objectkey,   
    error,
    touched,
    dispatchState
  } = props;

 const handleChange = (event) => {
      //console.log(reducerActions.ON_CHANGE_CHECKBOX);
      dispatchState({ 
        type: reducerActions.ON_CHANGE_CHECKBOX, 
        payload: { 
          key:objectkey,
          value: event.target.checked  
        } 
      });           
 }

 const handleBlur = () => {
   dispatchState({
     type: reducerActions.ON_BLUR_CHECKBOX,
     payload: objectkey
   });  
 }

  return (
    <>   
      <label htmlFor={field.fieldId}
          dangerouslySetInnerHTML={{ __html: field.fieldLabel || field.fieldName }}>
      </label>
      {field.fieldRequired && <span className="text-danger">*</span>}
     <Form.Check id={field.fieldId} isInvalid={field.isTouched && !field.isValid}
       className= "form-check-input">
      <Form.Check.Input
        ref={checkboxRef}       
        checked={Boolean(field.fieldValue)}
        onChange={handleChange}   
        onBlur={handleBlur}
        required={field.fieldRequired}
      
        isInvalid={field.isTouched && !field.isValid}
      />

      <Form.Control.Feedback type="invalid">
        {field.error}
      </Form.Control.Feedback>
    </Form.Check>
    </>
  );
});

export default CheckBoxBase;